// Resolves a `var(--token)` custom property (defined in styles/tokens.css,
// OKLCH-valued) to an rgb()/rgba() string. Needed because <canvas>-based
// libraries (lightweight-charts) parse the color string themselves for
// opacity/brightness operations and can't be trusted to understand oklch()
// — confirmed live: it throws "Cannot parse color: oklch(...)".
//
// getComputedStyle(...).color looked like a fix (let the DOM resolve it)
// but ISN'T reliable: modern Chromium serializes the CSSOM "resolved value"
// preserving the original CSS Color 4 function rather than downgrading to
// rgb() — so a computed-style probe can hand oklch() straight back out,
// which is exactly what broke this live (Overview page's price chart threw
// on mount instead of rendering). A 1x1 canvas readback is used instead:
// the 2D context always resolves any CSS color (oklch included) to raw
// RGBA bytes for painting, independent of how getComputedStyle serializes.
export function resolveCssVar(token: string): string {
  const probe = document.createElement("span");
  probe.style.color = `var(${token})`;
  probe.style.position = "absolute";
  probe.style.visibility = "hidden";
  probe.style.pointerEvents = "none";
  document.body.appendChild(probe);
  const cssColor = getComputedStyle(probe).color;
  document.body.removeChild(probe);

  const canvas = document.createElement("canvas");
  canvas.width = 1;
  canvas.height = 1;
  const ctx = canvas.getContext("2d");
  if (!ctx || !cssColor) return "rgb(0,0,0)";
  ctx.fillStyle = cssColor;
  ctx.fillRect(0, 0, 1, 1);
  const [r, g, b, a] = ctx.getImageData(0, 0, 1, 1).data;
  return a === 255 ? `rgb(${r},${g},${b})` : `rgba(${r},${g},${b},${(a / 255).toFixed(3)})`;
}
